import { Icon, Stack } from "@fluentui/react";
import {
  ToggleThumbIcon,
  TriangleSolidUp12Icon,
} from "@fluentui/react-icons-mdl2";
import React, { useState, useRef, useEffect, useContext } from "react";
import Emergency from "../../../components/SVGComponents/Emergency";
import Attention from "../../../components/SVGComponents/Attention";
import Medium from "../../../components/SVGComponents/Medium";
import NoAIOutput from "../../../components/SVGComponents/NoAIOutput";
import Low from "../../../components/SVGComponents/Low";
import High from "../../../components/SVGComponents/High";
import Critical from "../../../components/SVGComponents/Critical";
import ForeignBody from "../../../components/SVGComponents/ForeignBody";
import Suspect from "../../../components/SVGComponents/Suspect";
import {
  triageStackStyles,
  triageBoxStackStyle,
  triageDetailsStackStyle,
  priorityStackStyle,
  priorityTextStyle,
  remarkTextStyle,
  verticalLine,
  annotationDivStackStyle,
  annotationStyle,
  annotationStackStyle,
  expandButtonStyle,
  annotationReportedDivStackStyle,
} from "../helpers/ConstantStyles";
import { t } from "i18next";
import { PATHOLOGY_STATUS, TAB_NAME, USERTYPES } from "../../../constants/Constants";
import CustomToolTipHost from "../../../components/CustomToolTipHost/CustomToolTipHost";
import NavIcons from "../../../components/navbar/nav-icons/NavIcons";
import NonMedicalEmergency from "../../../components/SVGComponents/NonMediclEmergency";
import NonFrontal from "../../../components/SVGComponents/NonFrontal";
import themeContext from "../../../context/theme/ThemeContext";
import userContext from "../../../context/users/UserContext";

const TriageDetails = (props) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [delayHandler, setDelayHandler] = useState(null);
  const { themeName } = useContext(themeContext);
  const {roles, username, userId, privilegedFirmDoctor } = useContext(userContext)

  const predictionList = props.data.row.original.studyPredictionList;

  const handleExpandClick = (expandValue) => {
    setIsExpanded(expandValue);
  };

  const getColorForAnnotationTags = (percent) => {
    let per = 100 - percent;
    return "hsl(" + per + ",100%,45%)";
  };

  const checkForHourGlass = (study) => {
    if (
      (study.aiProcessed == 2 && study.aiEmergencyMax == -1) ||
      (study.reportDoneStatus != 2 && study.aiProcessed == 2)
      //|| (study.aiProcessed != 3 && !study.expReviewDoneStatus)
    ) {
      return true;
    } else {
      return false;
    }
  };

  const showPopUp = () => {
    clearTimeout(delayHandler);
    setDelayHandler(
      setTimeout(() => {
        setIsExpanded(true);
      }, 300)
    );
  };

  const hidePopUp = () => {
    clearTimeout(delayHandler);
    setDelayHandler(
      setTimeout(() => {
        setIsExpanded(false);
      }, 300)
    );
  };

  useEffect(() => {
    clearTimeout(hidePopUp);
  }, [isExpanded]);

  useEffect(() => {
    // const scrollElement = document.querySelector('.study-list-modal-scroll');
    // const tableContainer = document.querySelector('.table-container');
    // if (scrollElement || tableContainer) {
    // const handleMouseEnter = () => {
    //   scrollElement.classList.add('scrollbar-hovered');
    //   if (tableContainer) {
    //     tableContainer.classList.add('table-hovered');
    // }
    // };
    // const handleMouseLeave = () => {
    //   scrollElement.classList.remove('scrollbar-hovered');
    //   if (tableContainer) {
    //     tableContainer.classList.remove('table-hovered');
    // }
    // };
    // const handleMouseMove = (event) => {
    //     const scrollbarWidth = scrollElement.offsetWidth - scrollElement.clientWidth;
    //     const scrollbarRect = scrollElement.getBoundingClientRect();
    //     const scrollbarStartX = scrollbarRect.right - scrollbarWidth;
    //     const hoverStartX = scrollbarStartX - 5;
    //     const hoverEndX = scrollbarRect.right + 20; // 20px on the right side
    //     if (event.clientX >= hoverStartX && event.clientX <= hoverEndX) {
    //         scrollElement.classList.add('scrollbar-hovered');
    //     } else {
    //         scrollElement.classList.remove('scrollbar-hovered');
    //     }
    // };
    //   scrollElement.addEventListener('mouseenter', handleMouseEnter);
    //   scrollElement.addEventListener('mouseleave', handleMouseLeave);
    //   scrollElement.addEventListener('mousemove', handleMouseMove);
    //   return () => {
    //     scrollElement.removeEventListener('mouseenter', handleMouseEnter);
    //     scrollElement.removeEventListener('mouseleave', handleMouseLeave);
    //     scrollElement.removeEventListener('mousemove', handleMouseMove);
    // };
    //  }
  }, [document.querySelector(".study-list-modal-scroll")]);

  useEffect(() => {
    if (props.tabId === TAB_NAME.REPORTED) {
      let lists = [...props.data.row.original.studyPredictionList];
      function customSort(a, b) {
        if (a.aiPredicted && a.selected) {
          return -1;
        } else if (b.aiPredicted && b.selected) {
          return 1;
        } else if (!a.aiPredicted && !b.aiPredicted) {
          return 0;
        } else if (!a.aiPredicted) {
          return -1;
        } else if (!b.aiPredicted) {
          return 1;
        } else if (a.selected && !b.selected) {
          return -1;
        } else if (!a.selected && b.selected) {
          return 1;
        }
      }
      lists.sort(customSort);
      props.data.row.original.studyPredictionList = lists;
    }
  }, []);

  return (
    <>
      {
        <Stack
          horizontal
          style={triageStackStyles}
          data-tut={"tour-triage-details"}
        >
          <Stack
            horizontal
            className={`studylist-triage-container ${predictionList?.length > 0 ? "studylist-triage-flex":""}`}
            style={triageBoxStackStyle}
          >
            <Stack style={triageDetailsStackStyle}>
              <Stack horizontal style={priorityStackStyle} className={`${themeName === "light" && predictionList?.length > 0 ? "studylist-triage-details-header":""}`}>
                <span
                  className="studylist-triage-info-text"
                  style={priorityTextStyle}
                >
                  {props.data.row.original.emergency === true &&
                  !props.data.row.original.nonMedicalEmergency === true ? (
                    <>
                      <Emergency /> &nbsp;{t("study-list.badges.emergency")}
                    </>
                  ) : (
                    <></>
                  )}
                  {props.data.row.original.emergency === true &&
                  props.data.row.original.nonMedicalEmergency === true ? (
                    <>
                      <div>
                        <NonMedicalEmergency />
                      </div>{" "}
                      &nbsp;{t("study-list.badges.non-medical-emergency")}
                    </>
                  ) : (
                    <></>
                  )}
                  
                  {!props.data.row.original.emergency &&
                  props.data.row.original.attention === true && (!roles[0].includes(USERTYPES.FIRMDOCTOR) || privilegedFirmDoctor) && !roles[0].includes(USERTYPES.FIRMTECHNICIAN)? (
                    <>
                      <Attention /> &nbsp;{t("study-list.badges.attention")}
                    </>
                  ) : (
                    <></>
                  )}
                </span>
                {(!roles[0].includes(USERTYPES.FIRMDOCTOR) || privilegedFirmDoctor) && !roles[0].includes(USERTYPES.FIRMTECHNICIAN)&&(
                <span 
                  className="studylist-triage-info-text"
                  style={priorityTextStyle}
                >
                  {(props.data.row.original.aiEmergencyMax === -1 &&
                    props.data.row.original.aiProcessed == 0) ||
                  (props.data.row.original.reportDoneStatus != 2 &&
                    props.data.row.original.aiProcessed == 0) ||
                  props.data.row.original.aiProcessed == 3 ? (
                    <>
                      <div>
                        <NoAIOutput />
                      </div>{" "}
                      &nbsp;
                      {t("study-list.filters.no-ai-output")}
                    </>
                  ) : (
                    <></>
                  )}
                  {checkForHourGlass(props.data.row.original) ? (
                    <>
                      <Icon iconName="HourGlass" /> &nbsp;{" "}
                      {t("study-list.badges.in-progress")}...
                    </>
                  ) : (
                    <>
                      {props.data.row.original.aiEmergencyMax === -3 ? (
                        <>
                          <NonFrontal />
                          &nbsp; {t("study-list.filters.non-frontal")}
                        </>
                      ) : (
                        <></>
                      )}
                      {props.data.row.original.aiEmergencyMax === 1 ||
                      props.data.row.original.aiEmergencyMax === 0 ? (
                        <>
                          <Low />
                          &nbsp; {t("study-list.filters.low")}
                        </>
                      ) : (
                        <></>
                      )}
                      {props.data.row.original.aiEmergencyMax === 2 ? (
                        <>
                          <Medium />
                          &nbsp; {t("study-list.filters.medium")}
                        </>
                      ) : (
                        <></>
                      )}
                      {props.data.row.original.aiEmergencyMax === 3 ? (
                        <>
                          <High />
                          &nbsp; {t("study-list.filters.high")}
                        </>
                      ) : (
                        <></>
                      )}
                      {props.data.row.original.aiEmergencyMax === 4 ? (
                        <>
                          <Critical /> &nbsp; {t("study-list.filters.critical")}
                        </>
                      ) : (
                        <></>
                      )}
                      {props.data.row.original.aiEmergencyMax === 7 ? (
                        <>
                          <Suspect /> &nbsp;{t("study-list.filters.suspect")}
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  )}
                  {props.data.row.original.aiEmergencyMax === 6 ? (
                    <>
                      <ForeignBody /> &nbsp;{t("study-list.filters.fo-only")}
                    </>
                  ) : (
                    <></>
                  )}
                </span>
                  )}
              </Stack>
              {(!roles[0].includes(USERTYPES.FIRMDOCTOR) || privilegedFirmDoctor) && !roles[0].includes(USERTYPES.FIRMTECHNICIAN)&&(<>
              {props.data.row.original.xrayVersion === true &&
                props.data.row.original.studyClassificationPredictionList
                  .length > 0 && (
                  <Stack
                    style={annotationDivStackStyle}
                    className="modal-scroll"
                  >
                    {props.data.row.original.studyClassificationPredictionList
                      .length > 0 &&
                      props.data.row.original.studyClassificationPredictionList.map(
                        (prediction, index) => {
                          if (index < 2) {
                            return (
                              <Stack
                                key={index}
                                horizontal
                                style={annotationStackStyle}
                              >
                                <span
                                  className="studylist-triage-finding-text"
                                  style={{ justifyContent: "center" }}
                                >
                                  <span className="finding-text-triage-column">
                                    {prediction.classificationName}
                                  </span>
                                  {/* {process.env.REACT_APP_PROTECTED_MODE ==
                                    "false" && (
                                    <span>
                                      {"-"}&nbsp;&nbsp;&nbsp;
                                      {`${(prediction.prediction*100).toFixed(2)}%`}
                                    </span>
                                  )} */}
                                </span>
                              </Stack>
                            );
                          }
                        }
                      )}
                    {isExpanded && (
                      <div style={{ position: "relative" }}>
                        <PopUpAIPathologyDetails
                          data={props.data}
                          onClickOutside={() => {
                            setIsExpanded(false);
                          }}
                          hidePopUp={hidePopUp}
                          showPopUp={showPopUp}
                          show={isExpanded}
                          setIsExpanded={setIsExpanded}
                          tabId={props.tabId}
                        />
                      </div>
                    )}
                  </Stack>
                )}
              {props.data.row.original.xrayVersion === false &&
                props.tabId != TAB_NAME.REPORTED &&
                props.data.row.original.studyPredictionList.length > 0 && (
                  <Stack
                    style={annotationDivStackStyle}
                    className="modal-scroll"
                  >
                    {props.data.row.original.studyPredictionList.length > 0 &&
                      props.data.row.original.studyPredictionList.map(
                        (prediction, index) => {
                          if (index < 2) {
                            return (
                              <Stack
                                key={index}
                                horizontal
                                style={annotationStackStyle}
                              >
                                <span className="studylist-triage-finding-text"  style={{ justifyContent: `${props.data.row.original?.showProbability? '':'center'}` }}>
                                  <span className="finding-text-triage-column">
                                    {prediction.pathology.name}
                                  </span>
                                  {props.data.row.original.showProbability && process.env.REACT_APP_PROTECTED_MODE ==
                                    "false" && (
                                    <span>
                                      {"-"}&nbsp;&nbsp;&nbsp;
                                      {`${prediction.probabilityDisplay}%`}
                                    </span>
                                  )}
                                </span>
                              </Stack>
                            );
                          }
                        }
                      )}
                    {isExpanded && (
                      <div style={{ position: "relative" }}>
                        <PopUpAIPathologyDetails
                          data={props.data}
                          onClickOutside={() => {
                            setIsExpanded(false);
                          }}
                          hidePopUp={hidePopUp}
                          showPopUp={showPopUp}
                          show={isExpanded}
                          setIsExpanded={setIsExpanded}
                          tabId={props.tabId}
                        />
                      </div>
                    )}
                  </Stack>
                )}
              {props.data.row.original.xrayVersion === false &&
                props.tabId == TAB_NAME.REPORTED &&
                props.data.row.original.studyPredictionList.length > 0 && (
                  <Stack
                    style={annotationReportedDivStackStyle}
                    className="modal-scroll"
                  >
                    {props.data.row.original.studyPredictionList.length > 0 &&
                      props.data.row.original.studyPredictionList.map(
                        (prediction, index) => {
                          if (index < 2) {
                            return (
                              <React.Fragment key={index}>
                                <span
                                  className="studylist-triage-finding-text"
                                  style={{ padding: "0px" }}
                                >
                                  <PathologyDetails prediction={prediction} />
                                </span>
                              </React.Fragment>
                            );
                          }
                        }
                      )}
                    {isExpanded && (
                      <div style={{ position: "relative" }}>
                        <PopUpAIPathologyDetails
                          data={props.data}
                          onClickOutside={() => {
                            setIsExpanded(false);
                          }}
                          hidePopUp={hidePopUp}
                          showPopUp={showPopUp}
                          show={isExpanded}
                          setIsExpanded={setIsExpanded}
                          tabId={props.tabId}
                        />
                      </div>
                    )}
                  </Stack>
                )}
                </>)}
            </Stack>
          </Stack>
          {(!roles[0].includes(USERTYPES.FIRMDOCTOR) || privilegedFirmDoctor) && !roles[0].includes(USERTYPES.FIRMTECHNICIAN)&&(<>
          {props.data.row.original.xrayVersion === false &&
            props.data.row.original.studyPredictionList.length > 2 && (
              <div
                className="cursor-pointer"
                style={expandButtonStyle}
                onClick={() => handleExpandClick(true)}
                onMouseEnter={(e) => {
                  e.stopPropagation();
                  showPopUp();
                }}
                onMouseLeave={(e) => {
                  e.stopPropagation();
                  hidePopUp();
                }}
              >
                +{props.data.row.original.studyPredictionList.length - 2} more
              </div>
            )}
          {props.data.row.original.xrayVersion === true &&
            props.data.row.original.studyClassificationPredictionList.length >
              2 && (
              <div
                className="cursor-pointer"
                style={expandButtonStyle}
                onClick={() => handleExpandClick(true)}
                onMouseEnter={(e) => {
                  e.stopPropagation();
                  showPopUp();
                }}
                onMouseLeave={(e) => {
                  e.stopPropagation();
                  hidePopUp();
                }}
              >
                +
                {props.data.row.original.studyClassificationPredictionList
                  .length - 2}{" "}
                more
              </div>
            )}
            </>)}
        </Stack>
      }
    </>
  );
};

export default TriageDetails;

const PathologyDetails = (props) => {
  const prediction = props.prediction;

  const getTypeOfAcceptance = (aiPredicted, isSelected) => {
    switch (true) {
      case aiPredicted && isSelected:
        return PATHOLOGY_STATUS.VERIFIED;

      case aiPredicted && !isSelected:
        return PATHOLOGY_STATUS.REJECTED;

      case !aiPredicted && isSelected:
        return PATHOLOGY_STATUS.ADDED;

      default:
        return PATHOLOGY_STATUS.ADDED;
    }
  };

  const customTriageColumnTooltip = {
    root: "triage-details-pathology-name",
  };

  const checkForPercentagePresent = (aiPredicted, isSelected) => {
    if (process.env.REACT_APP_PROTECTED_MODE == "false") {
      if (!aiPredicted) {
        return false;
      }
      return true;
    }
    return false;
  };

  return (
    <>
      <div className="studylist-triage-reported-container">
        <CustomToolTipHost
          styles={customTriageColumnTooltip}
          id="path-percent"
          content={
            checkForPercentagePresent(
              prediction.aiPredicted,
              prediction.selected
            )
              ? `${prediction.pathology.name} - ${prediction.probabilityOriginalPercentage}%`
              : prediction.pathology.name
          }
        >
          <span>{prediction.pathology.name}</span>
        </CustomToolTipHost>
        <span style={{ display: "flex" }}>
          <PathologyIcon
            type={getTypeOfAcceptance(
              prediction.aiPredicted,
              prediction.selected
            )}
          />
        </span>
      </div>
    </>
  );
};

const PopUpAIPathologyDetails = (props) => {
  const ref = useRef(null);
  const { onClickOutside } = props;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside && onClickOutside();
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [onClickOutside]);

  if (!props.show) return null;

  return (
    <>
      <div
        ref={ref}
        onMouseEnter={props.showPopUp}
        onMouseLeave={props.hidePopUp}
        style={{
          padding: props.tabId != TAB_NAME.REPORTED ? "10px 15px" : "10px",
        }}
        className="study-list-triage-details-popup study-list-triage-arrow-up"
      >
        {props.data.row.original.xrayVersion === false &&
          props.data.row.original.studyPredictionList.length > 0 &&
          props.data.row.original.studyPredictionList.map(
            (prediction, index) => {
              if (index >= 2) {
                return props.tabId != TAB_NAME.REPORTED ? (
                  <Stack key={index} horizontal style={annotationStackStyle}>
                    <span className="studylist-triage-finding-text" style={{ justifyContent: `${props.data.row.original?.showProbability? '':'center'}` }}>
                      <span className="finding-text-triage-column">
                        {prediction.pathology.name}
                      </span>
                      {props.data.row.original.showProbability && process.env.REACT_APP_PROTECTED_MODE == "false" && (
                        <span>
                          {"-"}&nbsp;&nbsp;&nbsp;
                          {`${prediction.probabilityDisplay}%`}
                        </span>
                      )}
                    </span>
                  </Stack>
                ) : (
                  <React.Fragment key={index}>
                    <span
                      className="studylist-triage-finding-text"
                      style={{ padding: "0px" }}
                    >
                      <PathologyDetails prediction={prediction} />
                    </span>
                  </React.Fragment>
                );
              }
            }
          )}
        {props.data.row.original.xrayVersion === true &&
          props.data.row.original.studyClassificationPredictionList.length >
            0 &&
          props.data.row.original.studyClassificationPredictionList.map(
            (prediction, index) => {
              if (index >= 2) {
                return  (
                  <Stack key={index} horizontal style={annotationStackStyle}>
                    <span className="studylist-triage-finding-text">
                      <span className="finding-text-triage-column">
                        {prediction.classificationName}
                      </span>
                      {/* {process.env.REACT_APP_PROTECTED_MODE == "false" && (
                        <span>
                          {"-"}&nbsp;&nbsp;&nbsp;
                          {`${prediction.probabilityDisplay}%`}
                        </span>
                      )} */}
                    </span>
                  </Stack>
                
                );
              }
            }
          )}
      </div>
    </>
  );
};

const PathologyIcon = ({ type }) => {
  switch (true) {
    case type === "verified":
      return (
        <div className="triage-container">
          <NavIcons iconName="verified" />
          <span className="triage-verified-text">
            {t("study-list.badges.verified")}
          </span>
        </div>
      );

    case type === "added":
      return (
        <div className="triage-container">
          <NavIcons iconName="added" />
          <span className="triage-added-text">
            {t("study-list.badges.added")}
          </span>
        </div>
      );

    case type === "rejected":
      return (
        <div className="triage-container">
          <NavIcons iconName="rejected" />
          <span className="triage-rejected-text">
            {t("study-list.badges.rejected")}
          </span>
        </div>
      );
    default:
      return <></>;
  }
};
